module.exports = __webpack_public_path__ + "static/media/report-download.6e495d5b.svg";